import { render } from "./azureDisk.vue?vue&type=template&id=6a87b8e6"
import script from "./azureDisk.vue?vue&type=script&lang=js"
export * from "./azureDisk.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../github.com:rancher/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__